/**
 * DateTimeInputType enum
 */

export enum DateTimeInputType {
  DATETIME_LOCAL = 'datetime-local',
  DATE = 'date',
  TIME = 'time',
}
